// extracted by mini-css-extract-plugin
export default {"content":"kA","wrapper":"lA","gif":"mA","textContent":"nA","gifContainer":"oA","proteinGif":"pA","counter_img":"qA","usage-container":"rA","usage-list":"sA","checklist":"tA","counter_title":"uA","counter_wrapper":"vA","active":"wA","usage-counter":"xA","line":"yA"};
    if(module.hot) {
      // 1711394578524
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  